import { FeatureItem, ItemDetailsSelector } from '../../utils';
import {
	SensorProperties,
	SensorPropertiesProps,
} from '../SensorProperties';

import React from 'react';
import { Tab } from '../Tab';
import { getSensor } from '../../../../redux/asset/actions';
import { selectSensorById } from '../../../../redux/asset/selectors/asset';
import { useGlobalization } from '@Translations/useGlobalization';

interface SensorsTabProps extends Omit<SensorPropertiesProps, 'item'> {
	items: FeatureItem[];
	highlightAssets?: (assets: string[]) => void;
}

export const SensorsTab = ({
	items,
	highlightAssets,
	...other
}: SensorsTabProps): JSX.Element => {
	const { t } = useGlobalization();

	return (
		<Tab
			items={items}
			tabName={t('Sensors', {
				context: 'Property pane tab heading',
			}) ?? 'Sensors'}
			detailView={item => <SensorProperties item={item} {...other} />}
			getItemName={item => `${item.alias || item.sensorId}`}
			getItemDetailsAction={getSensor}
			getItemDetailsSelector={selectSensorById as ItemDetailsSelector}
			getItemDetailsOnList
			highlightAssets={highlightAssets}
		/>
	);
};
